// Signin
export const SIGNIN = 'userActions/SIGNIN';
export const SIGNIN_SUCCESS = 'userActions/SIGNIN_SUCCESS';
export const SIGNIN_FAILED = 'userActions/SIGNIN_FAILURE';

export const SIGNOUT = 'userActions/SIGNOUT';
export const LOAD_USER_FROM_LOCAL_STORAGE =
  'userActions/LOAD_USER_FROM_LOCAL_STORAGE';
export const INITIAL_LOAD_USER_DONE = 'userActions/INITIAL_LOAD_USER_DONE';

// Signup
export const SIGNUP = 'Signup/SIGNUP';
export const SIGNUP_SUCCESS = 'Signup/SIGNUP_SUCCESS';
export const SIGNUP_FAILED = 'Signup/SIGNUP_FAILED';

export const FORGOT_PASSWORD = 'userActions/FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'userActions/FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILED = 'userActions/FORGOT_PASSWORD_FAILED';

export const RESET_PASSWORD = 'userActions/RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'userActions/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED = 'userActions/RESET_PASSWORD_FAILED';

export const UPDATE_USER = 'userActions/UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'userActions/UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILED = 'userActions/UPDATE_USER_FAILED';
export const UPDATE_STATUS = 'userActions/UPDATE_STATUS';

export const RESET_STATE = 'userActions/RESET_STATE';

export const SEARCH_USERS = 'userActions/SEARCH_USERS';
export const SEARCH_USERS_SUCCESS = 'userActions/SEARCH_USERS_SUCCESS';
export const SEARCH_USERS_FAILED = 'userActions/SEARCH_USERS_FAILED';

export const FETCH_USERS_FOR_SPECIFIC_ROLE =
  'userActions/FETCH_USERS_SPECIFIC_TO_ROLE';
export const FETCH_USERS_FOR_SPECIFIC_ROLE_SUCCESS =
  'userActions/FETCH_USERS_SPECIFIC_TO_ROLE_SUCCESS';
export const FETCH_USERS_FOR_SPECIFIC_ROLE_FAILED =
  'userActions/FETCH_USERS_SPECIFIC_TO_ROLE_FAILED';

export const UPDATE_USER_ROLE = 'userActions/UPDATE_USER_ROLE';
export const UPDATE_USER_ROLE_SUCCESS = 'userActions/UPDATE_USER_ROLE_SUCCESS';
export const UPDATE_USER_ROLE_FAILED = 'userActions/UPDATE_USER_ROLE_FAILED';

export const FETCH_READERS = 'userActions/FETCH_READERS';
export const FETCH_READERS_SUCCESS = 'userActions/FETCH_READERS_SUCCESS';
export const FETCH_READERS_FAILED = 'userActions/FETCH_READERS_FAILED';

export function signout() {
  return {type: SIGNOUT};
}

export function resetState() {
  return {type: RESET_STATE};
}

export function loadUserFromLocalStorage() {
  return {type: LOAD_USER_FROM_LOCAL_STORAGE};
}

export function initialLoadUserDone(user) {
  return {type: INITIAL_LOAD_USER_DONE, user};
}

// Signin Actions
export function signin(credentials) {
  return {
    type: SIGNIN,
    credentials,
  };
}

export function signinSuccess(user) {
  return {
    type: SIGNIN_SUCCESS,
    user,
  };
}

export function signinFailed(err) {
  return {
    type: SIGNIN_FAILED,
    err,
  };
}

// Signup Actions
export function signup(userDetails) {
  return {
    type: SIGNUP,
    userDetails,
  };
}

export function signupSuccess(user) {
  return {
    type: SIGNUP_SUCCESS,
    user,
  };
}

export function signupFailed(error) {
  return {
    type: SIGNUP_FAILED,
    error,
  };
}

export function forgotPassword(email) {
  return {
    type: FORGOT_PASSWORD,
    email,
  };
}

export function forgotPasswordSuccess(user) {
  return {
    type: FORGOT_PASSWORD_SUCCESS,
    user,
  };
}

export function forgotPasswordFailed(error) {
  return {
    type: FORGOT_PASSWORD_FAILED,
    error,
  };
}

export function resetPassword(details) {
  return {
    type: RESET_PASSWORD,
    details,
  };
}

export function resetPasswordSuccess(user) {
  return {
    type: RESET_PASSWORD_SUCCESS,
    user,
  };
}

export function resetPasswordFailed(error) {
  return {
    type: RESET_PASSWORD_FAILED,
    error,
  };
}

export function updateUser(details, id) {
  return {
    type: UPDATE_USER,
    details,
    id,
  };
}

export function updateUserSuccess(user) {
  return {
    type: UPDATE_USER_SUCCESS,
    user,
  };
}

export function updateUserFailed(error, id) {
  return {
    type: UPDATE_USER_FAILED,
    error,
    id,
  };
}

export function updateStatus() {
  return {type: UPDATE_STATUS};
}

export function searchUsers(searchKey, pageSize, pageNumber) {
  return {
    type: SEARCH_USERS,
    searchKey,
    pageSize,
    pageNumber,
  };
}

export function searchUsersSuccess(user) {
  return {
    type: SEARCH_USERS_SUCCESS,
    user,
  };
}

export function searchUsersFailed(error) {
  return {
    type: SEARCH_USERS_FAILED,
    error,
  };
}

export function fetchUsersForSpecificRole(role, filters) {
  return {
    type: FETCH_USERS_FOR_SPECIFIC_ROLE,
    role,
    filters,
  };
}

export function fetchUsersForSpecificRoleSuccess(result) {
  return {
    type: FETCH_USERS_FOR_SPECIFIC_ROLE_SUCCESS,
    result,
  };
}

export function fetchUsersForSpecificRoleFailed(error) {
  return {
    type: FETCH_USERS_FOR_SPECIFIC_ROLE_FAILED,
    error,
  };
}

export function updateUserRole(id, masterRoleId) {
  return {
    type: UPDATE_USER_ROLE,
    masterRoleId,
    id,
  };
}

export function updateUserRoleSuccess(user) {
  return {
    type: UPDATE_USER_ROLE_SUCCESS,
    user,
  };
}

export function updateUserRoleFailed(error) {
  return {
    type: UPDATE_USER_ROLE_FAILED,
    error,
  };
}

export function fetchReaders(filters) {
  return {
    type: FETCH_READERS,
    filters,
  };
}

export function fetchReadersSuccess(user) {
  return {
    type: FETCH_READERS_SUCCESS,
    user,
  };
}

export function fetchReadersFailed(error) {
  return {
    type: FETCH_READERS_FAILED,
    error,
  };
}
